import genToken from "@utils/generateToken";

export const createDefaultCountry = (pricingTargetId) => ({
  country: "FR",
  n: 500,
  n_auto: 1.0,
  n_manual: 0.0,
  country_auto: 1.0,
  country_manual: 0.0,
  cpi_auto: 0.0,
  cpi_manual: 0.0,
  incidence_rate: 100,
  incidence_rate_auto: 1.0,
  incidence_rate_manual: 0.0,
  additional_incidence_ratio: undefined,
  additional_incidence_ratio_auto: 1.0,
  additional_incidence_ratio_manual: 0.0,
  translation_manual: undefined,
  monitoring_manual: undefined,
  token: genToken(),
  pricing_target_id: pricingTargetId,
});
